import { Box, IconButton, SxProps, Typography } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { FC } from "react";

interface ICopyCore {
  text: string;
  sxStyle?: SxProps;
}

export const CopyCore: FC<ICopyCore> = ({ text, sxStyle }) => {
  const { handleCopy } = useConfigPageContext();

  return (
    <Box sx={{ display: "flex", alignItems: "center", ...sxStyle }}>
      <IconButton onClick={() => handleCopy(text)} sx={{ p: 0.8, m: 0, mr: 1, ml: -0.8 }}>
        <ContentCopyIcon sx={{ color: "#9C9B9BFF", fontSize: "14px" }} />
      </IconButton>

      <Typography sx={{ fontSize: ".8rem", fontWeight: 500, letterSpacing: ".4px", whiteSpace: "nowrap", display: "block", }}>
        {text}
      </Typography>
    </Box>
  )
}